<div [ngClass]="{'hidden': loading}" class="frame-in" style="display: flex; align-items: center; justify-content: center;">
  <button type="button" class="leave-button" (click)="back2Profile()"></button>

  <div style="margin-top: 75px !important;  width: 80% !important; height: 75% !important;">

    <div class="action-buttons" style="transform: scale(0.75); margin-left: -120px">
      <button type="button" (click)="changeFilter(1)" [ngClass]="{'brighter': filter == 1}" class="current"></button>
      <button type="button" (click)="changeFilter(2)" [ngClass]="{'brighter': filter == 2}" class="past"></button>
    </div>

    <!--        <button type="button" class="slider-back" (click)="pageChanged({pageIndex: (pageIndex === 0 ? pageIndex : (pageIndex - 1))})"></button>-->
    <!--        <button type="button" class="slider-next" (click)="pageChanged({pageIndex: (pageIndex === (itemsCount - 1) ? pageIndex : (pageIndex + 1))})"></button>-->

    <div style="padding: 10px 0 10px 0 !important">

      <mat-card  appearance="outlined"  class="mat-cardBg">
        <mat-card-content>
          <table  mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)" matSort class="mat-elevation-z8 card-table mat-cardBg">

            <!-- Position Column -->
            <ng-container matColumnDef="title">
              <th class="textBold" mat-header-cell *matHeaderCellDef mat-sort-header> Lesson </th>
              <td mat-cell *matCellDef="let element"> {{element.title}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="startDate">
              <th class="textBold" mat-header-cell *matHeaderCellDef mat-sort-header> Start Date </th>
              <td mat-cell *matCellDef="let element"> {{element.startDate  | date: 'dd/MM/yyyy'}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="dueDate">
              <th class="textBold" mat-header-cell *matHeaderCellDef mat-sort-header> Due Date </th>
              <td mat-cell *matCellDef="let element"> {{element.dueDate  | date: 'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th class="textBold" mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
              <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="click-row"></tr>
          </table>
          <nav aria-label="Page navigation example" class="pagination-wrap">
            <ul class="pagination">
              <li class="page-item"><span class="page-link" (click)="pageChanged({pageIndex: (pageIndex === 0 ? pageIndex : (pageIndex - 1))})" href="#"><svg class="mat-paginator-icon" focusable="false" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></svg> </span></li>
              @for (item of createArray(itemsCount); track item; let i = $index) {
                <li class="page-item"><span class="page-link" (click)="pageChanged({pageIndex: i})" [class.active]="pageIndex === i" href="#">{{i + 1}}</span></li>
              }
              <li class="page-item"><span class="page-link" (click)="pageChanged({pageIndex: (pageIndex === (itemsCount - 1) ? pageIndex : (pageIndex + 1))})" href="#"> <svg class="mat-paginator-icon" focusable="false" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></span></li>
            </ul>
          </nav>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <img class="frame-bg" src="assets/images/progress/bg-assignment.png">
</div>
